import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import { connect } from 'dva';
import { ConnectState, ResourceCreatorPageModelState } from '@/models/connect';
import { Dispatch } from 'redux';
import { history } from 'umi';
import { FI18n, FUtil } from '@freelog/tools-lib';
import FPolicyList from '@/components/FPolicyList';
import {
  OnClick_step3_addPolicyBtn_Action,
  OnClick_step3_submitBtn_Action,
} from '@/models/collectionCreatorPage';
import PolicyTemplates from '@/components/FPolicyTemplates';
import FIcons from '@/components/FIcons';
import * as AHooks from 'ahooks';
import { FTourMgr } from '@/utils/FTourMgr';

interface Step3Props {
  dispatch: Dispatch;
  collectionCreatorPage: ResourceCreatorPageModelState;
}

function Step3({ dispatch, collectionCreatorPage }: Step3Props) {

  AHooks.useMount(() => {
    FTourMgr.init('collectionCreatorPage.step3', [
      {
        element: self.document.getElementById('collectionCreator.step3.addPolicy'),
        title: FI18n.i18nNext.t('tours_rqr_plan_create'),
        topOffset: 10,
        rightOffset: 10,
        bottomOffset: 10,
        leftOffset: 10,
      },
      {
        element: self.document.getElementById('collectionCreator.step3.policyTemplates'),
        title: FI18n.i18nNext.t('tours_rqr_plan_templates'),
      },
    ]);
  });

  return (<>
    <div style={{ height: 40 }} />
    <div className={styles.block}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {/*<FComponentsLib.FContentText text={'授权策略'} type={'highlight'} />*/}
        <FComponentsLib.FContentText text={FI18n.i18nNext.t('authplanmgnt_title')} type={'highlight'} />
        {
          collectionCreatorPage.step3_policies.length > 0 && (<FComponentsLib.FTextBtn
            style={{ fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 5 }}
            type='primary'
            onClick={async () => {
              dispatch<OnClick_step3_addPolicyBtn_Action>({
                type: 'collectionCreatorPage/onClick_step3_addPolicyBtn',
                payload: {},
              });
            }}>
            <FIcons.FPolicy style={{ fontSize: 14 }} />
            <span>添加策略</span>
          </FComponentsLib.FTextBtn>)
        }

      </div>
      {
        collectionCreatorPage.step3_policies.length === 0 && (<>
          <div style={{ height: 10 }} />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <FComponentsLib.FContentText text={'资源需添加授权策略才能上架到资源市场，开放签约。'} type={'additional2'} />
            <FComponentsLib.FContentText text={'授权策略，即资源对外授权范围和条件的申明，如支付10元获得一个月使用授权。'} type={'additional2'} />
            <div style={{ height: 20 }} />

            {/*{FI18n.i18nNext.tAuto('authplanmgnt_list_empty_btn')}*/}
            <div id={'collectionCreator.step3.addPolicy'} style={{ width: 'fit-content', height: 'fit-content' }}>
              <FComponentsLib.FRectBtn
                type={'primary'}
                onClick={() => {
                  dispatch<OnClick_step3_addPolicyBtn_Action>({
                    type: 'collectionCreatorPage/onClick_step3_addPolicyBtn',
                    payload: {},
                  });
                }}
              >{FI18n.i18nNext.tAuto('authplanmgnt_list_empty_btn')}</FComponentsLib.FRectBtn>
            </div>
          </div>
        </>)
      }

      {
        collectionCreatorPage.step3_policies.length > 0 && (<>
          <div style={{ height: 20 }} />
          <FPolicyList
            activeBtnShow={false}
            // allDisabledSwitch={true}
            dataSource={collectionCreatorPage.step3_policies}
            // onCheckChange={(data) => {
            //   if (data.using) {
            //     self._czc?.push(['_trackEvent', '授权信息页', '上线', '', 1]);
            //   }
            //   onPolicyStatusChange(data.id, data.using);
            // }}
          />
        </>)
      }

    </div>

    <div style={{ height: 5 }} />

    <div id={'collectionCreator.step3.policyTemplates'} className={styles.block}>
      <FComponentsLib.FContentText
        text={'策略模板'}
        type={'highlight'}
      />
      {/*<FComponentsLib.FContentText text={FI18n.i18nNext.tAuto('authplanmgnt_title_templates')} type={'highlight'}/>*/}
      <div style={{ height: 5 }} />
      {/*<FComponentsLib.FContentText*/}
      {/*  text={'点击下方推荐的策略模板，可以快速添加策略'}*/}
      {/*  type={'additional2'} />*/}
      <FComponentsLib.FContentText text={FI18n.i18nNext.t('authplanmgnt_title_templates_help')} type={'additional2'} />
      <div style={{ height: 20 }} />
      <div style={{ width: 'fit-content', height: 'fit-content' }}>
        <PolicyTemplates
          resourceTypeCode={collectionCreatorPage.step1_createdResourceInfo?.resourceTypeCode}
          onSelect={(value) => {
            dispatch<OnClick_step3_addPolicyBtn_Action>({
              type: 'collectionCreatorPage/onClick_step3_addPolicyBtn',
              payload: {
                defaultValue: value,
              },
            });
          }}
        />
      </div>
    </div>

    <div style={{ height: 30 }} />

    <div className={styles.btn}>

      {/*{FI18n.i18nNext.tAuto('rqr_step3_btn_later')}*/}
      <FComponentsLib.FTextBtn
        type={'default'}
        onClick={() => {
          history.replace(FUtil.LinkTo.collectionVersionInfo({
            collectionID: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
            // version: '1.0.0',
          }));
        }}
      >{FI18n.i18nNext.tAuto('cqr_step3_btn_later')}</FComponentsLib.FTextBtn>

      {/*{FI18n.i18nNext.tAuto('rqr_step3_btn_next')}*/}
      <FComponentsLib.FRectBtn
        disabled={false}
        type={'primary'}
        onClick={() => {
          dispatch<OnClick_step3_submitBtn_Action>({
            type: 'collectionCreatorPage/onClick_step3_submitBtn',
          });
        }}
      >{FI18n.i18nNext.tAuto('cqr_step3_btn_continue')}</FComponentsLib.FRectBtn>
    </div>
    <div style={{ height: 100 }} />
  </>);
}

export default connect(({ collectionCreatorPage }: ConnectState) => ({
  collectionCreatorPage: collectionCreatorPage,
}))(Step3);


